import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Card } from 'react-bootstrap';
import './Login.css';
import ApiService from '../../services/ApiService';
import { useNavigate } from 'react-router-dom';

function Login() {
  console.log('[Login] mount');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);
    try {
      const { token, user } = await ApiService.login({ email, password });
      setSuccess('Login OK');
      console.log('JWT:', token, 'User:', user);
      navigate('/admin');
    } catch (err) {
      setError(err?.message || 'Error de autenticación');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center align-items-center h-100">
          <Col xs={12} sm={10} md={7} lg={5} xl={4}>
            <Card className="login-card">
              <Card.Body>
                <div className="d-flex flex-column align-items-center mb-3">
                  <img src="/logo.png" alt="Cajas Amanecer" className="login-logo mb-2" />
                  <h4 className="login-title mb-0">Iniciar sesión</h4>
                </div>
                {error && <Alert className="login-alert" variant="danger">{error}</Alert>}
                {success && <Alert className="login-alert" variant="success">{success}</Alert>}
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="loginEmail">
                    <Form.Control
                      className="login-input"
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="loginPassword">
                    <Form.Control
                      className="login-input"
                      type="password"
                      placeholder="Contraseña"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Button type="submit" variant="dark" disabled={loading} className="w-100 login-button">
                    {loading ? 'Ingresando…' : 'Ingresar'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;


